import de from './de.json';
import en from './en.json';

export const I18N_RESOURCES = {
  en,
  de,
} as const;

export type Locale = keyof typeof I18N_RESOURCES;
export const SUPPORTED_LOCALES = Object.keys(I18N_RESOURCES) as Locale[];

export const DEFAULT_LOCALE: Locale = 'en';
